import { Monotonicity } from '@/services/models/enums'
import { Interval } from '@/types/variable'

export function getIntervalArrayMonotonicity(
  intervals: Interval[],
): Monotonicity {
  if (intervals.length <= 1) return Monotonicity.ascending

  const isAscending =
    intervals[0].lowerBound < intervals[intervals.length - 1].upperBound
  const isDescending =
    intervals[0].lowerBound > intervals[intervals.length - 1].upperBound

  for (let i = 1; i < intervals.length; i++) {
    if (isAscending && intervals[i - 1].upperBound > intervals[i].lowerBound)
      return Monotonicity.nonMonotonic
    if (isDescending && intervals[i - 1].upperBound < intervals[i].lowerBound)
      return Monotonicity.nonMonotonic
  }

  return isAscending ? Monotonicity.ascending : Monotonicity.descending
}
